module.exports = "/images/logo-lonewolf-icon.png?87f4a890b8b8d6916eac2b5dd425058a";